// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-not-found[data-v-6861f6a2] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  font-size: 40px;\n  font-weight: bold;\n  flex-direction: column;\n  padding-bottom: 100px;\n}\n.page-not-found p[data-v-6861f6a2] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
